import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = 'https://ohllmsaklzfbepnivvfc.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im9obGxtc2FrbHpmYmVwbml2dmZjIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDczMTYwNTEsImV4cCI6MjA2Mjg5MjA1MX0.mMLKxlJqnh1MdN3vdvcEuSyBouIurCpiihlcJhwZepM';

// GUARD: Prevenir múltiplas instâncias do Supabase Client
const getSupabaseClient = () => {
  if ((window as any).__SUPABASE_CLIENT__) {
    return (window as any).__SUPABASE_CLIENT__;
  }

  const client = createClient<Database>(SUPABASE_URL, SUPABASE_ANON_KEY, {
    auth: {
      storage: typeof window !== 'undefined' ? window.localStorage : undefined,
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
      flowType: 'pkce'
    },
    realtime: {
      params: { eventsPerSecond: 10 }
    }
  });

  (window as any).__SUPABASE_CLIENT__ = client;
  return client;
};

export const supabase = getSupabaseClient();
